import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { AddUpdate, decrypt, getData } from "../../../ApiMethods/ApiMethods";
import {
  get_Expense_Category,
  get_Expeses,
  get_Single_Expenses,
} from "../../../store/actions/CommanAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import { Dropdown, Tab, Nav, Modal, Button } from "react-bootstrap";
import { customStyles } from "../Utility/Utility";
import DataTable from "react-data-table-component";
import { set } from "date-fns";

export default function AddExpenseEntry() {
  const dispatch = useDispatch();
  const ExpenseCategory = useSelector(
    (state) => state.feedBackReducer.ExpenseCategory
  );

  const categoryOptions = ExpenseCategory?.map((cat) => ({
    value: cat.Category.replace(/^"|"$/g, ""),
    label: cat.Category.replace(/^"|"$/g, ""),
  }));
 

  const Expeses = useSelector((state) => state.feedBackReducer.GetDataExpeses);


  const SingleExpense = useSelector(
    (state) => state.feedBackReducer.GetSinglaDataExpeses
  );

  const [expense, setExpense] = useState({
    title: "",
    category: "",
    date: null,
    paymentMode: "",
    cgstPercent: "",
    cgstAmount: "",
    amount: "",
    description: "",
    receipt: null,
    invoiceNo: "",
    sgstPercent: "",
    sgstAmount: "",
    igstAmount: "",
    igstPercent: "",
    originalAmount: "",
  });
  const [receiptName, setReceiptName] = useState("");
  const [EditValue, setEditValue] = useState(null);
  const [paymentModes, setPaymentModes] = useState([]);
  const [loading, setloading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [IsActive, setIsActive] = useState(true);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (EditValue) {
      const cleanedCategory = EditValue.Category
        ? EditValue.Category.replace(/^"|"$/g, "")
        : "";

      console.log("Populating expense with:", {
        category: EditValue.Category,
        paymentMode: EditValue.PaymentMode,
      });

      setExpense({
        ...expense,
        title: EditValue.ExpenseTitle || "",
        category: EditValue.Category || "",
        date: EditValue.ExpenseDate ? new Date(EditValue.ExpenseDate) : null,
        paymentMode: EditValue.PaymentMode || "",
        invoiceNo: EditValue.invoiceNo || "",
        amount: EditValue.TotalAmount || "",
        description: EditValue.ExpenseDescription || "",
        sgstPercent: EditValue.sgstPercent || "",
        sgstAmount: EditValue.sgstAmount || "",
        igstPercent: EditValue.igstPercent || "",
        igstAmount: EditValue.igstAmount || "",
        cgstPercent: EditValue.cgstPercent || "",
        cgstAmount: EditValue.cgstAmount || "",
        receipt: EditValue.Receipt || null,
        originalAmount: EditValue.OriginalAmount || "",
      });

      setReceiptName(EditValue.Receipt || "");
    }
  }, [EditValue]);

  const paymentdata = async () => {
    const res = await getData(
      "ExpenseCategory/GetDropDwonData_PaymentGatewayStatus"
    );

    setPaymentModes(res || []);
  };

  const Editfuncion = async (id) => {
    if (id) {
      await dispatch(get_Single_Expenses(id));
      setId(id);
      setShowModal(true);
    }
  };

  useEffect(() => {
    if (SingleExpense) {
      setEditValue(SingleExpense[0]);
    }
  }, [SingleExpense]);

  useEffect(() => {
    paymentdata();
    dispatch(get_Expeses("1"));
  }, []);
  useEffect(() => {
    dispatch(get_Expense_Category("1", setloading));
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    let updatedExpense = { ...expense };

    if (name === "receipt") {
      updatedExpense.receipt = files[0];
      setReceiptName(files[0]?.name || "");
    } else {
      updatedExpense[name] = value;

      if (
        name === "originalAmount" ||
        name === "cgstPercent" ||
        name === "sgstPercent" ||
        name === "igstPercent"
      ) {
        const originalAmount =
          parseFloat(
            name === "originalAmount" ? value : updatedExpense.originalAmount
          ) || 0;

        const cgstPercent =
          parseFloat(
            name === "cgstPercent" ? value : updatedExpense.cgstPercent
          ) || 0;

        const sgstPercent =
          parseFloat(
            name === "sgstPercent" ? value : updatedExpense.sgstPercent
          ) || 0;

        const igstPercent =
          parseFloat(
            name === "igstPercent" ? value : updatedExpense.igstPercent
          ) || 0;

        const cgstAmount = (originalAmount * cgstPercent) / 100;
        const sgstAmount = (originalAmount * sgstPercent) / 100;
        const igstAmount = (originalAmount * igstPercent) / 100;

        updatedExpense.cgstAmount = cgstAmount.toFixed(2);
        updatedExpense.sgstAmount = sgstAmount.toFixed(2);
        updatedExpense.igstAmount = igstAmount.toFixed(2);

        const totalAmount =
          originalAmount + cgstAmount + sgstAmount + igstAmount;
        updatedExpense.amount = totalAmount.toFixed(2);
      }
    }

    setExpense(updatedExpense);
  };

  const handleDateChange = (date) => {
    setExpense({ ...expense, date });
  };

  const calculateGSTAmount = () => {
    const amount = parseFloat(expense.amount) || 0;
    return ((amount * (parseFloat(expense.cgstPercent) || 0)) / 100).toFixed(2);
  };
  const calculateOriginalAmount = () => {
    const total = parseFloat(expense.amount) || 0;
    const cgstPercent = parseFloat(expense.cgstPercent) || 0;
    return (total / (1 + cgstPercent / 100)).toFixed(2);
  };
  const calculateTotalAmount = () => {
    return (parseFloat(expense.amount) || 0).toFixed(2);
  };

  const Reset = () => {
    setExpense({
      title: "",
      category: "",
      date: null,
      paymentMode: "",
      cgstPercent: "",
      cgstAmount: "",
      amount: "",
      description: "",
      receipt: null,
      invoiceNo: "",
      sgstPercent: "",
      sgstAmount: "",
      igstAmount: "",
      igstPercent: "",
      originalAmount: "",
      
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...expense,
      date: expense.date ? expense.date.toISOString() : "",
    };

    const obj = {
      ExpenseTitle: expense?.title,
      Category:expense?.category,
      ExpenseDate: expense.date ? expense.date.toISOString() : "",
      PaymentMode: expense.paymentMode,
      OriginalAmount: expense.originalAmount,

      TotalAmount: expense.amount,
      CreatedByUser: "1",
      ExpenseDescription: expense.description,

      InvoiceNo: expense.invoiceNo,
      sgstPercent: expense.sgstPercent,
      sgstAmount: expense.sgstAmount,
      igstPercent: expense.igstPercent,
      igstAmount: expense.igstAmount,
      cgstPercent: expense.cgstPercent,
      cgstAmount: expense.cgstAmount,
      IsActive: true,
    };
    const formData = new FormData();
    formData.append("Data", JSON.stringify(obj));
    if (expense.receipt) {
      formData.append("Receipt", expense.receipt);
    }

    await AddUpdate("Expense/Insert_Expense", formData);
    Reset();
    setShowModal(false);
    dispatch(get_Expeses("1"));
  };

  const paymentModeOptions = paymentModes?.map((mode) => ({
    value: mode.Description,
    label: mode.Description,
  }));

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #fdba74",
      borderRadius: 6,
      fontSize: 14,
      backgroundColor: "#fff",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(253, 186, 116, 0.2)"
        : "none",
      borderColor: state.isFocused ? "#fdba74" : "#fdba74",
      minHeight: 39,
      outline: "none",
      ":hover": {
        borderColor: "#fdba74",
      },
    }),
  };

  const columns = [
     {
      name: "InvoiceNo",
      selector: (row) => row.invoiceNo? row.invoiceNo:"null",
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.ExpenseTitle,
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.ExpenseDescription,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => row.TotalAmount,
      sortable: true,
    },
    {
      name: "Payment Mode",
      selector: (row) => row.PaymentMode,
      sortable: true,
    },
    {
      name: "Expense Date",
      selector: (row) => row.ExpenseDate,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{
            position: "absolute",
            top: "7px",
            right: 50,
            zIndex: "999999999999",
          }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div>
          <Dropdown drop="up">
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu alignRight className="dropdown-menu-right">
              <Dropdown.Item
                style={{ color: "black" }}
                onClick={() => Editfuncion(row.ExpenseID, true)}
              >
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                style={{ color: "red" }}
                onClick={() => Deletefuncion(row.ExpenseID)}
              >
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      width: "100px",
    },
  ];

  const Deletefuncion = async (id) => {
    if (id) {
      const obj = { ExpenseID: id, DeleteByUser: "1", IsActive: false };
      await AddUpdate("Expense/Delete_Expense", obj);
    }
    dispatch(get_Expeses("1"));
  };

  const closfunction = () => {
    setShowModal(false);
    setId(null);
  };
  const updatefunction = async (e) => {
    e.preventDefault();

    const data = {
      ...expense,
      date: expense.date ? expense.date.toISOString() : "",
    };

    const obj = {
      ExpenseTitle: expense.title,
      Category: expense.category,
      ExpenseDate: expense.date ? expense.date.toISOString() : "",
      PaymentMode: expense.paymentMode,
      OriginalAmount: expense.originalAmount,

      TotalAmount: expense.amount,
      ModifiedByUser: "1",
      ExpenseDescription: expense.description,

      InvoiceNo: expense.invoiceNo,
      sgstPercent: expense.sgstPercent,
      sgstAmount: expense.sgstAmount,
      igstPercent: expense.igstPercent,
      igstAmount: expense.igstAmount,
      cgstPercent: expense.cgstPercent,
      cgstAmount: expense.cgstAmount,
      IsActive: true,
      ExpenseID: id,
    };
    const formData = new FormData();
    formData.append("Data", JSON.stringify(obj));
    // formData.append("Receipt", obj.Receipt);
    await AddUpdate("Expense/UpDate_Expense", formData);
    Reset();
    setShowModal(false);
    dispatch(get_Expeses("1"));
  };

  return (
    <>
      <div style={{}}>
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Expenses</h2>
        <button
          style={{
            padding: "10px 20px",
            background: "#ea580c",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            marginBottom: 20,
          }}
          onClick={() => {
            setShowModal(true);
            Reset();
            setId(null);
          }}
        >
          + Add Expense
        </button>
      </div>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 24,
              borderRadius: 12,
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
              maxHeight: "90vh",
              overflowY: "auto",
              width: "70%",
            }}
          >
            <button
              style={{
                float: "right",
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
              onClick={() => setShowModal(false)}
            >
              &times;
            </button>

            <h2 className="heading" style={{ color: "#ea580c" }}>
              Add Expense Entry
            </h2>

            <div className="position-relative">
              <form
                className="form-card"
                onSubmit={handleSubmit}
                style={{
                  background: "#fff",
                  padding: 24,
                  borderRadius: 12,
                  boxShadow: "0 2px 8px #0001",
                }}
              >
                <div className="form-row" style={{ display: "flex", gap: 16 }}>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Expense Title</label>
                    <input
                      type="text"
                      name="title"
                      placeholder="Enter expense title"
                      value={expense.title}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Category</label>

                    <Select
                      name="category"
                      value={categoryOptions.find(
                        (option) => option.value == expense.category
                      )}
                      onChange={(selectedOption) =>
                        setExpense({
                          ...expense,
                          category: selectedOption ? selectedOption.value : "",
                        })
                      }
                      options={categoryOptions}
                      placeholder="Select category"
                      styles={customSelectStyles}
                      isClearable
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Invoice No.</label>
                    <input
                      type="text"
                      name="invoiceNo"
                      placeholder="Enter invoice number"
                      value={expense.invoiceNo}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{ display: "flex", gap: 16, marginTop: 10 }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Payment Mode</label>
                    <Select
                      name="paymentMode"
                      value={paymentModeOptions.find(
                        (option) => option.value === expense.paymentMode
                      )}
                      onChange={(selectedOption) =>
                        setExpense({
                          ...expense,
                          paymentMode: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      options={paymentModeOptions}
                      placeholder="Select payment mode"
                      styles={customSelectStyles}
                      isClearable
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Date</label>
                    <div style={{ width: "100%" }}>
                      <DatePicker
                        selected={expense.date}
                        onChange={handleDateChange}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        placeholderText="Select date"
                        isClearable
                      />
                    </div>
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Original Amount (₹)</label>
                    <input
                      type="number"
                      name="originalAmount"
                      onChange={handleChange}
                      value={expense.originalAmount}
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{ display: "flex", gap: 16, marginTop: 10 }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>IGST (%)</label>
                    <input
                      type="number"
                      name="igstPercent"
                      value={expense.igstPercent}
                      onChange={handleChange}
                      min="0"
                      max="100"
                      required
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>IGST Amount (₹)</label>
                    <input
                      type="number"
                      name="igstAmount"
                      readOnly
                      onChange={handleChange}
                      value={expense.igstAmount}
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{ display: "flex", gap: 16, marginTop: 10 }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>CGST (%)</label>
                    <input
                      type="number"
                      name="cgstPercent"
                      value={expense.cgstPercent}
                      onChange={handleChange}
                      min="0"
                      max="100"
                      required
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>CGST Amount (₹)</label>
                    <input
                      type="number"
                      name="cgstAmount"
                      readOnly
                      onChange={handleChange}
                      value={expense.cgstAmount}
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>SGST (%)</label>
                    <input
                      type="number"
                      name="sgstPercent"
                      value={expense.sgstPercent}
                      onChange={handleChange}
                      min="0"
                      max="100"
                      required
                    />
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label>SGST Amount (₹)</label>
                    <input
                      type="number"
                      name="sgstAmount"
                      readOnly
                      onChange={handleChange}
                      value={expense.sgstAmount}
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{ display: "flex", gap: 16, marginTop: 16 }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Total Amount (₹)</label>
                    <input
                      type="number"
                      name="amount"
                      placeholder="Enter total amount including GST"
                      value={expense.amount}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Upload Receipt/Invoice</label>
                    <input
                      // disabled
                      type="file"
                      name="receipt"
                      accept="image/*,application/pdf"
                      onChange={handleChange}
                    />
                    {/* {receiptName && (
              <span style={{ marginLeft: 8 }}>{receiptName}</span>
            )} */}
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{ display: "flex", gap: 16, marginTop: 10 }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label>Expense Description</label>
                    <textarea
                      name="description"
                      placeholder="Describe the expense details"
                      value={expense.description}
                      onChange={handleChange}
                      rows={3}
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{
                    display: "flex",
                    gap: 16,
                    marginTop: 16,
                    alignItems: "center",
                  }}
                >
                  <div
                    className="form-group"
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <div className="button-group">
                      <button className="bg-danger" onClick={closfunction}>
                        Close
                      </button>
                      {id ? (
                        <button onClick={updatefunction}>Update</button>
                      ) : (
                        <button className="bg-success" type="submit">
                          Save{" "}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="table-responsive">
        <DataTable
          dense
          columns={columns}
          data={Expeses}
          selectableRowsHighlight
          highlightOnHover
          pagination
          persistTableHead={true}
          noDataComponent={"There are no data to display"}
          customStyles={customStyles}
        />
      </div>
    </>
  );
}
